class LinkedContinents
{
	constructor(data){
		this.continents = data;
	}

	static userHasContinentSettings(user){
		return user && user.location && user.location.country && user.location.country.continent_id;
	}

	static getContinentIdFromUser(user){
		if(LinkedContinents.userHasContinentSettings(user))
		{
			return user.location.country.continent_id;
		}
		return null;
	}

	usersHaveLinkedContinents(user1, user2){
		if(!LinkedContinents.getContinentIdFromUser(user1) || !LinkedContinents.getContinentIdFromUser(user2))
		{
			console.log('missing a linked continennt');
			return false;
		}
		return this.isLinked(LinkedContinents.getContinentIdFromUser(user1), LinkedContinents.getContinentIdFromUser(user2))
	}
	
	isLinked(firstId, secondId){
		if(firstId == secondId)
		{
			return true;
		}
		return this.continents[firstId] && this.continents[firstId][secondId];
	}

}

export {LinkedContinents}